export default function buildUniqueArray<T>(arr: ReadonlyArray<T>): T[] {
  // ToDo: for real uniqueness: deep sort the items before stringifying them
  const itemStrings = arr
    .map((item) => {
      try {
        return JSON.stringify(item)
      } catch {
        return undefined
      }
    })
    .filter((item) => item !== undefined)

  const itemSet = new Set<string>(itemStrings)

  return [...itemSet]
    .map((item) => {
      try {
        return JSON.parse(item)
      } catch {
        return undefined
      }
    })
    .filter((item) => item !== undefined)
}
